import React, { useEffect, useState } from "react";
import { DatePicker, Flex, Modal, Select } from "antd";
import { Button, Form, Input } from "antd";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { Typography } from "antd";
import TextArea from "antd/es/input/TextArea";
import { BASE_API_URL } from "../../../utils/consts";
import dayjs from "dayjs";

const { Option } = Select;
const { Text } = Typography;

type Props = {
  isOpen: boolean;
  onCloseModal: () => void;
  mode?: "create" | "edit";
  modalData?: any;
  locations: any;
  clientId: any;
  onUpdate: () => void;
  workSectors: any;
};

const RevenueTypesModal: React.FC<Props> = ({
  isOpen,
  onCloseModal,
  locations,
  mode = "create",
  modalData,
  clientId,
  onUpdate,
  workSectors,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [activeLocation, setActiveLocation] = useState<any>(undefined);

  // ✳️ Kad se modal otvori, automatski popuni formu u edit modu
  useEffect(() => {
    if (isOpen) {
      if (mode === "edit" && modalData) {
        form.setFieldsValue({
          revenueTypeName: modalData.name,
          workSector: modalData.sectorId?._id || modalData.sectorId,
          notes: modalData.notes,
        });
        setActiveLocation({
          value: modalData.sectorId?._id || modalData.sectorId,
        });
      } else {
        form.resetFields();
        form.setFieldsValue({
          date: dayjs(),
        });
      }
    }
  }, [isOpen, mode, modalData, form]);

  const handleCancel = () => {
    onCloseModal();
    form.resetFields();
  };

  const onFinish = async (values: any) => {
    try {
      if (mode === "create") {
        await axios.post(
          `${BASE_API_URL}/admin/${clientId}/createRevenueType`,
          {
            name: values.revenueTypeName,
            sectorId: activeLocation?.value || values.workSector,
            notes: values.notes,
          }
        );
      } else if (mode === "edit" && modalData) {
        await axios.put(
          `${BASE_API_URL}/admin/${clientId}/updateRevenueType/${modalData._id}`,
          {
            name: values.revenueTypeName,
            sectorId: activeLocation?.value || values.workSector,
            notes: values.notes,
          }
        );
      }
      onUpdate();
      form.resetFields();
      onCloseModal();
    } catch (err) {
      console.error("Error saving revenue type:", err);
    }
  };

  return (
    <Modal
      title={mode === "edit" ? t("Edit Revenue Type") : t("Add Revenue Type")}
      open={isOpen}
      onCancel={handleCancel}
      className="standardHeader"
      footer={[]}
    >
      <Form
        name="revenueTypeForm"
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label={t("Revenue Type Name")}
          name="revenueTypeName"
          rules={[{ required: true, message: t("Revenue type name required") }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="workSector"
          label={t("Work Sector")}
          rules={[{ required: true, message: "Please select sector!" }]}
        >
          <Select
            placeholder={t("Select sector")}
            onChange={(value, data) => setActiveLocation(data)}
          >
            {workSectors?.map((item: any, index: number) => (
              <Option value={item._id} key={index}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={t("Notes")}
          name="notes"
          rules={[{ required: false }]}
        >
          <TextArea rows={2} />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Flex gap="small" wrap="wrap">
            <Button type="primary" htmlType="submit">
              {t("Save")}
            </Button>
            <Button onClick={handleCancel}>{t("Cancel")}</Button>
          </Flex>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RevenueTypesModal;
